import * as React from 'react'
import config from './config'
import './App.css'
import Snack from './Snack'
import EditorState from './state/EditorState'
import LoginState from './state/LoginState'
import CssBaseline from '@material-ui/core/CssBaseline'

const api = require('./api/api')

class App extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			ready: false,
			appState: "login"
		}
	}

	componentDidMount(){
		document.title = 'Together Admin Page'

		api.util.config().then(res => {
			config.server = res.config

			this.setState({
				ready: true
			})
		}).catch(err => {
			console.error(err)

			this.setState({
				ready: true
			})
		})
	}

	setAppState(state) {
		this.setState({
			appState: state
		})	
	}

	parseState(state) {
		switch (state) {
			case "editor": return <EditorState setAppState={this.setAppState.bind(this)} />
		}

		return <LoginState setAppState={this.setAppState.bind(this)} />
	}

	render() {
		return (
			<React.StrictMode>
				<link rel='stylesheet' href='https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap'/>
				<CssBaseline />
				<Snack />

				{ this.parseState(this.state.appState) }
			</React.StrictMode>
		)
	}
}

export default App